import List from 'components/List/List';
import withAboutPageQuery, { WithAboutPageQueryProps } from 'enhancers/withAboutPageQuery';
import withCountry from 'enhancers/withCountry';
import withFAQState from 'enhancers/withFAQState';
import withLanguageState, { WithLanguageProps } from 'enhancers/withLanguageState';
import * as React from 'react';
import Placeholder from 'react-placeholder';
import styled from 'styled-components';

type Props = WithAboutPageQueryProps & WithLanguageProps;

const FAQ = withFAQState(List);

export const FaqPage: React.SFC<Props> = props => {
  const color =
    !props.loading &&
    props.data &&
    props.data.fetch.Common.About &&
    props.data.fetch.Common.About.Color
      ? props.data.fetch.Common.About.Color
      : '#333';

  const containerBackground =
    !props.loading &&
    props.data &&
    props.data.fetch.Common.FAQ &&
    props.data.fetch.Common.FAQ.BackgroundColor
      ? props.data.fetch.Common.FAQ.BackgroundColor
      : '#333';

  const hasLists = !props.loading && props.data && props.data.fetch.Country;
  const background =
    hasLists &&
    props.data &&
    props.data.fetch.Common.FAQ &&
    props.data.fetch.Common.FAQ.Lists &&
    props.data.fetch.Common.FAQ.Lists.QuestionsBackground
      ? props.data.fetch.Common.FAQ.Lists.QuestionsBackground
      : '#fff';

  const menuColor =
    hasLists &&
    props.data &&
    props.data.fetch.Common.FAQ &&
    props.data.fetch.Common.FAQ.Lists &&
    props.data.fetch.Common.FAQ.Lists.NumberBackground
      ? props.data.fetch.Common.FAQ.Lists.NumberBackground
      : '#eeeeee';

  const activeColor =
    hasLists &&
    props.data &&
    props.data.fetch.Common.FAQ &&
    props.data.fetch.Common.FAQ.Lists &&
    props.data.fetch.Common.FAQ.Lists.NumberActiveBackground
      ? props.data.fetch.Common.FAQ.Lists.NumberActiveBackground
      : '#333333';

  return (
    <div style={{ background: containerBackground }}>
      <TopContainer>
        <Top>
          <Heading style={{ color }}>
            <Placeholder
              showLoadingAnimation={true}
              ready={!props.loading}
              rows={1}
            >
              {!props.loading &&
                props.data &&
                props.getText(props.data.fetch.Country.AboutPage.Title)}
            </Placeholder>
          </Heading>
          <Subtitle style={{ color }}>
            <Placeholder
              showLoadingAnimation={true}
              ready={!props.loading}
              rows={1}
            >
              {!props.loading &&
                props.data &&
                props.getText(props.data.fetch.Country.AboutPage.Subtitle)}
            </Placeholder>
          </Subtitle>
        </Top>
      </TopContainer>

      <Placeholder
        showLoadingAnimation={true}
        ready={!props.loading}
        type="rect"
        style={{ height: 300 }}
      >
        {!props.loading && props.data ? (
          <FAQ
            menu={{ background, color: menuColor, activeColor }}
            background={background}
            items={props.data.fetch.Country.AboutPage.FAQs.map(item => ({
              content: props.getText(item.Content),
              title: props.getText(item.Title)
            }))}
          />
        ) : (
          []
        )}
      </Placeholder>
    </div>
  );
};

const Heading = styled.h3`
  text-transform: uppercase;
  font-size: 35px;
  margin-bottom: 15px;
  margin-top: 55px;
  @media (max-width: 900px) {
    margin-top: 15px;
    font-size: 25px;
  }
`;

const Subtitle = styled.div`
  margin-bottom: 55px;
  text-align: center;
  @media (max-width: 900px) {
    margin-bottom: 15px;
  }
`;

const TopContainer = styled.div`
  display: flex;
  justify-content: center;
`;

const Top = styled.div`
  max-width: 900px;
  padding: 15px;
`;
export default withLanguageState(withCountry(withAboutPageQuery(FaqPage)));



// WEBPACK FOOTER //
// ./src/pages/FaqPage/FaqPage.tsx